import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { Clock, LogOut, Sparkles } from "lucide-react";

export function Pending() {
  const { user, logout, refreshMe } = useAuth();
  return (
    <div className="min-h-screen bg-grid flex items-center justify-center p-5" data-testid="pending-view">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md glass rounded-3xl p-8 border border-white/10 text-center">
        <div className="h-14 w-14 rounded-2xl grid place-items-center bg-amber-500/15 mx-auto mb-5">
          <Clock className="h-7 w-7 text-amber-400" />
        </div>
        <h1 className="font-display font-extrabold text-xl mb-2">Account in attesa di approvazione</h1>
        <p className="text-sm text-slate-400 mb-6">
          Ciao {user?.name}! Il tuo account è stato creato correttamente. L'amministratore deve ancora
          assegnarti un ruolo e sbloccare l'accesso alle sezioni. Riprova più tardi.
        </p>
        <div className="flex flex-col gap-2">
          <button data-testid="pending-refresh" onClick={refreshMe}
            className="w-full py-2.5 rounded-xl bg-indigo-500 text-white text-sm font-semibold hover:bg-indigo-400 transition-colors">
            Ho ricevuto l'approvazione · Aggiorna
          </button>
          <button data-testid="pending-logout" onClick={logout}
            className="w-full py-2.5 rounded-xl bg-white/5 border border-white/10 text-sm text-slate-300 hover:bg-white/10 transition-colors flex items-center justify-center gap-2">
            <LogOut className="h-4 w-4" /> Esci
          </button>
        </div>
      </motion.div>
    </div>
  );
}
